module.exports = __webpack_public_path__ + "img/Differentiation-CRC_GSE225857.edbe5800.png";